<template>
  <div class="tradein-option-group">
    <div v-if="heading" class="heading body-s-medium">
      {{ heading }}
    </div>

    <div class="parent-container">
      <template v-for="option in options">
        <BaseTradeInOptionItem
          v-if="option.enabled"
          :key="option.value"
          :label="option.label"
          :badgeLabel="option.badgeLabel"
          :badgeColor="option.badgeColor"
          :selected="value === option.value"
          @click="onSelect(option.value)"
        />
      </template>
    </div>

    <!-- esc -->
    <div v-if="optionMeta.desc" class="tradein-type-desc">
      <v-icon size="16">mdi-information</v-icon>
      <span v-html="optionMeta.desc"></span>
    </div>
  </div>
</template>

<script>
import BaseTradeInOptionItem from './BaseTradeInOptionItem.vue'

export default {
  name: 'BaseTradeInOptionGroup',

  components: {
    BaseTradeInOptionItem,
  },

  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
      default: null,
    },
    heading: {
      type: String,
      default: null,
    },
  },

  model: {
    prop: 'value',
    event: 'update:value',
  },

  computed: {
    optionMeta() {
      return (
        this.options.find(option => option.value === this.value) ?? {
          label: '',
          badgeLabel: null,
          badgeColor: null,
        }
      )
    },
  },

  methods: {
    onSelect(value) {
      this.$emit('update:value', this.value === value ? null : value)
    },
  },
}
</script>

<style lang="stylus" scoped>
.tradein-option-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.heading {
    color: rgba(#000000, 0.85);
}

.parent-container {
    ::v-deep .trade-in-item-container {
        &:first-of-type .trade-in-item {
            border-radius: 8px 8px 0 0;
        }

        &:last-of-type .trade-in-item {
            border-radius: 0 0 8px 8px;
        }

        &:first-of-type:last-of-type .trade-in-item {
            border-radius: 8px;
        }

        &:not(.-is-selected):not(:last-of-type) .trade-in-item {
            border-bottom-color: transparent;
        }
    }
}

.tradein-type-desc {
	width: 100%;
	background-color: rgba($color-red, 0.1)
    border-radius: 8px
    padding: 8px 16px
    margin-top: 16px

    font-size: 14px
	font-weight: bold
    color: $color-red

    display: flex
    align-items: center
    gap: 8px

    .v-icon {
        color: $color-red
    }
}
</style>
